module.exports = __webpack_public_path__ + "static/media/commentTwitter.205683dd.svg";